const urlParams = new URLSearchParams(window.location.search)
const id = urlParams.get('id')
const token = urlParams.get('token')

export default class InvoiceDownload {
    constructor($el) {
        this.$el = $el
        this.api = document.getElementById('ps-invoice-download-api').value
        this.$success = document.getElementById('ps-invoice-download-success')
        this.$error = document.getElementById('ps-invoice-download-error')
    }

    init() {
        this.$success.style.display = 'none'
        this.$error.style.display = 'none'
        if (id && token) {
            this.makeRequest(id, token)
        }
    }

    makeRequest(id, token) {
        let success = this.$success
        let error = this.$error
        let xhr = this.createCORSRequest('GET', `${this.api}/${id}`);
        if (!xhr) {
            throw new Error('CORS not supported');
        }

        xhr.setRequestHeader('Accept', 'application/pdf')
        xhr.setRequestHeader('Authorization', `Bearer ${token}`)
        xhr.responseType = 'blob'

        xhr.onload = function () {
            if (xhr.status === 200) {
                success.style.display = 'block'
                let textnode = document.createTextNode(' If it doesn\'t, please ')
                success.appendChild(textnode)
                const downloadURL = window.URL.createObjectURL(xhr.response)
                const link = document.createElement('a')
                link.href = downloadURL
                link.download = id + '.pdf'
                link.text = 'download invoice'
                link.click()
                success.appendChild(link)
            } else {
                error.style.display = 'block'
            }
           
        };

        xhr.onerror = function () {
            // handle error
            error.style.display = 'block'
        };
        xhr.send();
    }

    createCORSRequest(method, url) {
        let xhr = new XMLHttpRequest()
        if ('withCredentials' in xhr) {
            // Check if the XMLHttpRequest object has a "withCredentials" property.
            // "withCredentials" only exists on XMLHTTPRequest2 objects.
            xhr.open(method, url, true)

        } else if (typeof XDomainRequest != 'undefined') {
            // Otherwise, check if XDomainRequest.
            // XDomainRequest only exists in IE, and is IE's way of making CORS requests.
            xhr = new XDomainRequest()
            xhr.open(method, url)

        } else {
            // Otherwise, CORS is not supported by the browser.
            xhr = null
        }
        return xhr;
    }
}



// WEBPACK FOOTER //
// ./js/modules/InvoiceDownload.js